export default __webpack_public_path__ + "static/media/Spring21_16.13fd5a85.png";